export const months = [
  { description: '', id: 'NONE' },
  { description: 'January', id: '01' },
  { description: 'February', id: '02' },
  { description: 'March', id: '03' },
  { description: 'April', id: '04' },
  { description: 'May', id: '05' },
  { description: 'June', id: '06' },
  { description: 'July', id: '07' },
  { description: 'August', id: '08' },
  { description: 'September', id: '09' },
  { description: 'October', id: '10' },
  { description: 'November', id: '11' },
  { description: 'December', id: '12' }
]

export const monthNumberToMonth = (monthNumber) =>{
  let thismonth = months.find((a)=>parseInt(a.id)==parseInt(monthNumber));
  if(!thismonth)return "NONE"
  return thismonth.description
}

export const licenseValidationList = {
  STEEL_IMPORT_LICENSE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Department of Commerce. "
},
SINGAPORE_TPL_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the government of Singapore. "
},
CANADIAN_NAFTA_TPL_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the certificate’s issuer. "
},
MEXICAN_NAFTA_TPL_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied " +
	"by the certificate’s issuer. "
},
BEEF_EXPORT_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the certificate’s issuer. "
},
DIAMOND_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Office of Foreign Asset Control (OFAC). "
},
ATPDEA_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the certificate’s issuer. "
},
AUSTRALIA_FREE_TRADE_EXPORT_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Government of Australia. "
},
MEXICAN_CEMENT_IMPORT_LICENSE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Department of Commerce. "
},
CAFTA_TPL_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Government of Nicaragua. "
},
ATLANTIC_LUMBER_BOARD_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the ALB. "
},
COTTON_SHIRTING_FABRIC_LICENSE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Department of Commerce. "
},
HAITI_EARNED_IMPORT_ALLOWANCE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied " +
	"by the Office of Textiles and Apparel. "
},
AGRICULTURAL_LICENSE : {
	regex: /^\d\-[a-zA-Z ]{2}\-\d{3}\-\d$/,
	message: "Length: 10 characters."+
	"Acceptable Format(s): In the format supplied"+
	"by the Department of Agriculture: "+
	"N-AA-NNN-N "+
	"N-AB-NNN-N "+
	"(Where N = numeric, A = alphabetic, and B ="+
	"space. Include the dashes as indicated). "
},
CANADIAN_EXPORT_SUGAR_CERTIFICATE : {
	regex: /^.{1,8}$/,
	message: "Length: Not more than 8 characters. "
},
WOOL_LICENSE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Department of Commerce. "
},
CBTPA_CERTIFICATION : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Department of Commerce. "
},
AGOA_TEXTILE_PROVISION_NUMBER : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the certificate’s issuer. "
},
USDA_SUGAR_CERTIFICATE : {
	regex: /^[cfCF]\d[a-zA-Z]{3}.\d{3}$/,
	message: "Sugar Certificate format is ANAAAXNNN (where N = numeric, A = alphabetic, X = alphanumeric) and the following restrictions will apply: \n"+

	"The first character MUST be either a ‘C’ (for a calendar year issued license/certificate) or an ‘F’ (for a fiscal year issued license/certificate).\n"+
	"The second character MUST be the single digit year the license/certificate was issued (e.g., ‘1’ for a license issued in 2021).\n"+
	"The referenced license/certificate is only allowed to be used in the year (calendar or fiscal) that it was issued.\n"
},
ORGANIC_PRODUCT_EXEMPTION_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by AMS. "
},
AMS_CERTIFICATE_OF_EXEMPTION : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the National Processed Raspberry Council. "
},
DOMINICAN_REPUBLIC_EARNED_ALLOWANCE_PROGRAM_CERTIFICATE : {
	regex: /^.{1,9}$/,
	message: "Length: Not more than 9 characters. "+
	"Acceptable Format(s): In the format supplied "+
	"by the Office of Textiles and Apparel. "
},
MEXICAN_SUGAR_EXPORT_LICENSE : {
	regex: /^.{2}[0-9]{7}$/,
	message: "Length: 9 characters. Acceptable Format: AANNNNNNN. (Where N = numeric and A = alphanumeric). "
},
GENERAL_NOTE_15_WAIVER_CERTIFICATE : {
	regex: /^.{9}$/,
	message: "Length: 9 characters. Acceptable Format: In the format supplied by USDA. "
}
}




export const availablePGAs = [
  { id: 'FDA', description: 'PGA Agency Code' },
  { id: 'FDA', description: 'PGA Program Code' }
]

export const packagingQualifiers = [
  {
    "value": "1",
    "description": "OUTERMOST"
  },
  {
    "value": "2",
    "description": "INNERMOST OR NEXT SMALLEST"
  },
  {
    "value": "3",
    "description": "INNERMOST OR NEXT SMALLEST"
  },
  {
    "value": "4",
    "description": "INNERMOST OR NEXT SMALLEST"
  },
  {
    "value": "5",
    "description": "INNERMOST OR NEXT SMALLEST"
  },
  {
    "value": "6",
    "description": "INNERMOST"
  },
]

export const packagingQualifiersDynamic = (packagingQualfierValue, entireList)=>{
	if(!entireList || !entireList.length)return "INVALID";
	if(!packagingQualfierValue){
		return "PLEASE SELECT"
	}
	if(parseInt(packagingQualfierValue) == entireList.length){
		return `${packagingQualfierValue}. INNERMOST`;
	}
	if(parseInt(packagingQualfierValue) == 1){
		return `${packagingQualfierValue}. OUTERMOST`;
	}
	return `${packagingQualfierValue}. NEXT SMALLEST OUTER`;


}

export const govAgencyCodesDEV = [
  {
    value: 'RED',
    description: 'Radiation Emitting Devices'
  },
  {
    value: 'NED',
    description: 'Non-Radiation Emitting Devices'
  }
]

export const govAgencyCodesRAD = [
  {
    value: 'REP',
    description: 'Non-Medical Radiation-Emitting Product'
  }
]

export const govAgencyCodesBIO = [
	{
	  	value: 'ALG',
	  	description: 'Allergenics'
	},
	{
	  	value: 'BBA',
	  	description: 'Blood Bag with Anti-coagulant'
	},
	{
		value: 'BDP',
		description: 'Blood Derivatives'
	},
	{
		value: 'BLD',
		description: 'Licensed Devices'
	},
	{
		value: 'BLO',
		description: 'Blood and Blood Products'
	},
	{
		value: 'CGT',
		description: 'Cell and Gene Therapy'
	},
	{
		value: 'HCT',
		description: 'Human Cells and Tissue'
	},
	{
		value: 'PVE',
		description: 'Plasma Volume Expanders'
	},
	{
		value: 'VAC',
		description: 'Vaccines'
	},
	{
		value: 'XEN',
		description: 'Xenotransplants'
	}
]

export const govAgencyCodesVME = [
	{
		value: 'ADR',
		description: 'Animal Drug'
	},
	{
		value: 'ADE',
		description: 'Animal Device'
	}
  ]

export const intendedUseCodeBIO = [
	{
	  	value: '080.000',
	  	description: 'For Human Medical Use as a Non Food Product under Controlled Distribution'
	},
	{
	  	value: '082.000',
	  	description: 'For Immediate use by authorized medical officials in the medical treatment of humans'
	},
    {
		value: '100.000',
		description: 'For private non-commercial use under the FDA personal importation policy (PIP)'
	},
    {
		value: '110.000',
		description: 'For Public Exhibition or Display as a Non-Food Product'
	},
	{
		value: '140.000',
		description: 'For Charitable Organization Use as Non-Food Product. Ex : For improving living conditions during a natural disaster'
	},
    {
		value: '150.007',
		description: 'For commercial processing as a Non-Food product; for processing into a pharmaceutical product'
	},
	{
		value: '155.000',
		description: 'For Commercial Assembly as a Non-Food Product'
	},
    {
		value: '170.000',
		description: 'For repair of a Non-Food Product'
	},
    {
		value: '180.000',
		description: 'For Research and Development as a Non-Food Product'
	},
    {
		value: '180.009',
		description: 'Biological or chemical for research and development into a pharmaceutical product'
	},
    {
		value: '180.016',
		description: 'For processing samples submitted to CBER for lot release testing'
	},
    {
		value: '920.000',
		description: 'For return to the US'
	},
    {
		value: '940.000',
		description: 'Import of a Compassionate Use/Emergency Use Device'
	},
	{
		value: '970.000',
		description: 'For Immediate Re-Exportation'
	}
]

export const intendedUseCodeVME = [
    {
        "value": "085.003",
        "description": "Drug subject of a new animal drug application, conditionally approved application, or Index listing"
    },
    {
        "value": "085.000",
        "description": "For Veterinary Medical Use as a Non-Food Product"
    },
    {
        "value": "100.000",
        "description": "Importation for Personal Use"
    },
    {
        "value": "150.013",
        "description": "Active Pharmaceutical Ingredient / Bulk Drug Substance to be used for Pharmacy Compounding"
    },
    {
        "value": "150.020",
        "description": "Active Pharmaceutical Ingredient / Bulk Drug Substance used to be further manufactured into a finished drug subject of a new animal drug application, conditionally approved application, or Index listing"
    },
    {
        "value": "180.009",
        "description": "For research and development in a pharmaceutical product - clinical investigations in animals (INAD or JINAD)"
    },
    {
        "value": "180.018",
        "description": "For research and development in a pharmaceutical product for tests in-vitro or in laboratory research animals"
    },
    {
        "value": "920.000",
        "description": "US Goods Returned"
    },
    {
        "value": "970.000",
        "description": "Import for Export"
    },
    {
        "value": "980.000",
        "description": "For Other Use : (APIs or Finished Drugs not elsewhere classified)"
    }
]

export const fdaBioUomList = [
    {
        "value": "AE",
        "description": "Aerosol"
    },
    {
        "value": "AM",
        "description": "Ampoule, Nonprotected"
    },
    {
        "value": "AP",
        "description": "Ampoule, Protected"
    },
    {
        "value": "AT",
        "description": "Atomizer"
    },
    {
        "value": "BA",
        "description": "Barrel"
    },
    {
        "value": "BC",
        "description": "Bottle crate, Bottle rack"
    },
    {
        "value": "BG",
        "description": "Bag"
    },
    {
        "value": "BO",
        "description": "Bottle, Non-Protected, Cyl"
    },
    {
        "value": "BQ",
        "description": "Bottle, Protected, Cylindrical"
    },
    {
        "value": "BS",
        "description": "Bottle, Nonprotected, Bulbous"
    },
    {
        "value": "BV",
        "description": "Bottle, Protected Bulbous"
    },
    {
        "value": "BX",
        "description": "Box"
    },
    {
        "value": "CA",
        "description": "Can, Rectangular"
    },
    {
        "value": "CI",
        "description": "Canister"
    },
    {
        "value": "CON",
        "description": "Container"
    },
    {
        "value": "CS",
        "description": "Case"
    },
    {
        "value": "CT",
        "description": "Carton"
    },
    {
        "value": "CX",
        "description": "Can, Cylindrical"
    },
    {
        "value": "CY",
        "description": "Cylinder"
    },
    {
        "value": "DR",
        "description": "Drum"
    },
    {
        "value": "EN",
        "description": "Envelope"
    },
    {
        "value": "FD",
        "description": "Framed Crate"
    },
    {
        "value": "GB",
        "description": "Gas Bottle"
    },
    {
        "value": "MB",
        "description": "Bag, Multi-ply"
    },
    {
        "value": "PAL",
        "description": "Pallet"
    },
    {
        "value": "PC",
        "description": "Parcel"
    },
    {
        "value": "PK",
        "description": "Package"
    },
    {
        "value": "SY",
        "description": "Syringe"
    },
    {
        "value": "VI",
        "description": "Vial"
    },
    {
        "value": "TU",
        "description": "Tube"
    },
    {
        "value": "VP",
        "description": "Vacuum Packed"
    },
    {
        "value": "VL",
        "description": "Bulk Liquid"
    },
    {
        "value": "AU",
        "description": "Allergy Units (ml or tablet)"
    },
    {
        "value": "BAU",
        "description": "Bioequivalent Allergy Units (ml or tablet)"
    },
    {
        "value": "CAP",
        "description": "Capsule"
    },
    {
        "value": "CG",
        "description": "Centigrams"
    },
    {
        "value": "FOZ",
        "description": "Ounces, fluid"
    },
    {
        "value": "G",
        "description": "Grams"
    },
    {
        "value": "GAL",
        "description": "Gallons (US)"
    },
    {
        "value": "KG",
        "description": "Kilograms"
    },
    {
        "value": "L",
        "description": "Liters"
    },
    {
        "value": "LB",
        "description": "Pounds (avdp)"
    },
    {
        "value": "MG",
        "description": "Milligrams"
    },
    {
        "value": "ML",
        "description": "Milliliters"
    },
    {
        "value": "MCG",
        "description": "Micrograms"
    },
    {
        "value": "NO",
        "description": "Number"
    },
    {
        "value": "OZ",
        "description": "Ounces, weight (avdp)"
    },
    {
        "value": "PCS",
        "description": "Pieces"
    },
    {
        "value": "PNU",
        "description": "Protein Nitrogen Units"
    },
    {
        "value": "PTL",
        "description": "Pints, liquid (US)"
    },
    {
        "value": "QTL",
        "description": "Quarts, liquid (US)"
    },
    {
        "value": "TAB",
        "description": "Tablets"
    }
]

export const fdaVmeBaseUomList = [
	"BBL",
	"BOL",
	"CAP",
	"CFT",
	"CG",
	"CM",
	"CM3",
	"CYD",
	"FOZ",
	"FT",
	"G",
	"GAL",
	"KG",
	"KM",
	"KM2",
	"KM3",
	"L",
	"LB",
	"LNM",
	"M",
	"M2",
	"M3",
	"MG",
	"MCG",
	"ML",
	"OZ",
	"PCS",
	"PTL",
	"QTL",
	"STN",
	"SUP",
	"T",
	"TAB",
	"TON",
	"TOZ"
]

export const fdaVmeUsecodeAocMapper = {
	"085.003": ["REG", "NDC", "VAN"],
	"150.013": ["REG", "NDC"],
	"150.020": ["REG", "NDC", "VAN"],
	"180.009": ["VIN"],
	"980.000": ["REG", "NDC"]
}

export const lotNumbers = [
  {
    value: '1',
    description: 'MANUFACTURER'
  },
  {
    value: '3',
    description: 'GROWER'
  },
]

export const aocComplianceRequiredOptions = {
	FDA_TOB: ["TST"],
	FDA_COS: ["COS"],
	FDA_DEV: ["DA","DDM","DEV","DFE","DI","IDE","IND","LST","PM#","ACC","ANC","CCM","MDL","RA1","RA2","RA5","RA7","RB2","RC2","RD3"],
	FDA_DRU: ["DA","DLS","FSR","IDE","IND","LST","PM#","PRN","REG"],
	FDA_RAD: ["ACC","ANC","CCM","MDL","RA1","RA2","RA5","RA7","RB2","RC2","RD3"],
	FDA_FOO: ["AIN","CAN","CCC","CFR","CIN","FAP","FCC","FCE","FME","GFR","IBP","IFR","JIF","LFR","ORN","PFR","PKC","RNO","SFR","SID","SIF","SRN","TFR","UFR","VES","VFT","VOL","VQI","REG","VFL"],
	FDA_BIO: ["BLN","DA","DLS","HRN","IND","REG","STN"],
	FDA_VME: ["NDC","REG","VAN","VFL","VIN","VNA"]
}

export const govAgencyCodesNmfsAmr = [
	{
		value: 'FRE',
		description: 'Fresh'
	},
	{
		value: 'FRZ',
		description: 'Frozen'
	}
]
export const getExclusionHTSES = (entryDate)=>{
  const JUNE_15_2024 = 1718409600000;
  if(entryDate >= JUNE_15_2024){
    return ["8483509040","8607211000","9030904600","8413919085","8413919096","8414308030","8414308060","8419903000","8420999000","8421210000","8421390115","8421390190","8421990140","8431200000","8436800090","8436990090","8479909596","8481909020","8481909040","8501104020","8501104060","8501312000","8501514040","8501538040","8504907500","8536904000","9015808080","9018119000","9018120000","9018199530","9018199550","9018199560","9018903000","9018906000","9022120000","9022140000","9022904000","9022906000","9032100030","9025198010","9025198020","9025198085","3906905000","3919102055","3919905040","3919905060","3920620090","8407909010","8424899000","8501106080","8501314000","8536308000","8536507000","8543704500","8543709860","8711100000","9027102000","0304725000","0304831015","0304831020","0304835015","0304835020","0304835090","3808945010","3923210095","5603920070","5603920095","5603930090","6505008015","8424909080","8425310100","1605102010","1605102022","1605102030","1605102090","2805110000","2917125000","2929905095","3815110000","3815190000","3923500000","4202923120","5007200065","5007200085","6001102000","6802990090","6909112000","7007190000","7009100000","7016100000","7326908688","8205513030","8413309090","8414596540","8414596560","8418500080","8473301180","8473305100","8501404020","8501404040","8504409580","8511400000","8516290090","8534000020","8534000040","8537109170","8543709100","8544422000","8544429090","8708407570","8716400000","9401616011","9401710031","9401790035","9401919090","9403995005","0505100050","0505100055","3401190000","3926909910","5504100000","6210105010","6210105090","6506106030","3913100000","3926909985","6111206070","6302100020","6302319040","6307909891","6506106045","8452100090","8524119000","8529901300","9004900010","9004900090","9005100040","9401911500","9401991085","9404901060","9404901090"];
  }
  return ["1605102010","1605102022","1605102030","1605102090","2917125000","2926200000","2929905090","3401190000","3801105000","3801105000","3801900000","3808931500","3815110000","3815190000","3815190000","3815190000","3815190000","3815190000","3815190000","3815190000","3815190000","3824780020","3824780020","3824999297","3824999397","3827620000","3827620000","3906905000","3913100000","3919102020","3919102030","3919102055","3919905040","3919905060","3920435000","3920620090","3921121100","3921190000","3923210095","3923500000","3923500000","3924905650","3926209050","3926909910","3926909985","3926909985","3926909985","3926909985","3926909985","3926909990","3926909990","3926909990","3926909990","3926909990","4010359000","4202128130","4202920400","4202923120","4202923131","4202923131","4205008000","4814900200","4823700020","4823700040","5007200065","5007200085","5108108000","5210114040","5210116020","5407522060","5407522060","5407522060","5407619930","5407619930","5407619935","5407720015","5501200000","5501400000","5504100000","5512190090","5603120090","5603149090","5603920090","5603930090","5603949090","5701901010","5810929080","6001102000","6003406000","6108910030","6111206070","6111206070","6111206070","6111206070","6111305015","6207911000","6208911020","6208920020","6301300010","6301300020","6302100020","6302319020","6302319040","6307909889","6307909889","6307909891","6307909891","6505008015","6506106030","6506106045","6802990060","6802990060","6909112000","7007190000","7007190000","7009100000","7009100000","7016100000","7308400000","7321111060","7321906090","7326908688","7501200000","7616995190","8205513030","8207907585","8207907585","8302500000","8302500000","8303000000","8407909010","8409919290","8409919990","8409919990","8412210045","8412390080","8412909081","8413309090","8413702004","8413810040","8413919010","8413919080","8413919080","8413919080","8413919085","8413919085","8413919085","8413919095","8413919095","8413919095","8413919096","8413919096","8413919096","8414100000","8414200000","8414308030","8414308060","8414596540","8414596560","8418500080","8418500080","8419120000","8419190040","8419903000","8420109040","8420109080","8420109080","8420999000","8420999000","8421210000","8421210000","8421210000","8421220000","8421390115","8421398015","8421990040","8421990040","8421990140","8421990140","8423810040","8424899000","8424909080","8425310100","8425390100","8425490000","8428900290","8428900390","8430100000","8431200000","8431200000","8431390010","8431499095","8432290060","8436800090","8436990090","8452100090","8452299000","8471609050","8471706000","8473301180","8473301180","8473301180","8473305100","8479899499","8479909496","8479909596","8481100090","8481805090","8481909020","8481909020","8481909040","8481909040","8481909040","8481909040","8481909040","8481909040","8481909040","8481909040","8483509040","8483908010","8501104020","8501104060","8501106020","8501106080","8501312000","8501314000","8501314000","8501314000","8501314000","8501314000","8501314000","8501316000","8501402040","8501404020","8501404040","8501404040","8501406040","8501514040","8501538040","8501538040","8504404000","8504404000","8504408500","8504408500","8504409580","8504907500","8508110000","8508110000","8511400000","8512902000","8514908000","8516290030","8516290030","8516290090","8516290090","8516604070","8516808000","8517620090","8518220000","8524119000","8525601010","8525803010","8525803010","8525803010","8525803010","8525810000","8525810000","8525810000","8525820000","8525820000","8525820000","8525830000","8525893000","8525893000","8525893000","8525893000","8529901300","8532220085","8534000020","8534000020","8534000040","8536308000","8536507000","8536509025","8536509025","8536509065","8536509065","8536694010","8536904000","8536904000","8536904000","8537109170","8543309080","8543704500","8543704500","8543709100","8543709860","8543709860","8543709860","8543709960","8543709960","8543709960","8544422000","8544429010","8544429090","8544429090","8544429090","8544606000","8546900000","8607211000","8607301000","8708295060","8708295160","8708305090","8708407570","8708407570","8708407570","8708407570","8708508500","8708996890","8708998180","8711100000","8711600000","8711600050","8711600090","8712001510","8712001520","8712001550","8712002500","8712002500","8712003500","8714913000","8716400000","8716903000","9004900000","9004900010","9004900090","9005100040","9011108000","9011800000","9011800000","9011900000","9013809000","9014802000","9015808080","9015900190","9015900190","9015900190","9018199560","9018199560","9018906000","9022120000","9022140000","9022902500","9022904000","9022906000","9022906000","9022906000","9025198010","9025198010","9025198020","9025198020","9025198040","9025198040","9025900600","9027102000","9027905650","9029108000","9030904600","9032100030","9032894000","9106908500","9401616011","9401710031","9401710031","9401790035","9401790050","9401901085","9401904080","9401905081","9401905081","9401905081","9401911500","9401919090","9401991085","9401999081","9401999081","9401999081","9403200050","9403200080","9403200081","9403200081","9403200090","9403820015","9403906005","9403995005","9404901000","9405408440","9405408440","9405428440","9405428440","9405504000","9405994090","0304725000","0304831015","0304831020","0304835015","0304835015","0304835020","0304835090","0505100050","0505100055","9903"];
} 
export const subExclusionHTSES = ["99038869","99038801", "99038802", "99038803", "99038804", "99038815"]
const additionalHTSForSteelMeltAndPour = [
    "7216910010",
    "7302909000",
    "73071930",
    "73071990",
    "04029968",
    "04029970",
    "04029990",
    "2106909998",
    "2710193050",
    "2711120020",
    "2804290010",
    "2804400000",
    "2901220000",
    "2903421000",
    "29034310",
    "29034410",
    "29034510",
    "29034900",
    "29035110",
    "29035990",
    "2903710100",
    "3004909244",
    "32081000",
    "32082000",
    "32089000",
    "32091000",
    "32099000",
    "32139000",
    "32141000",
    "33030010",
    "33030020",
    "33030030",
    "33043000",
    "33049950",
    "33051000",
    "33053000",
    "33059000",
    "33069000",
    "33071010",
    "33071020",
    "33072000",
    "33074900",
    "33079000",
    "34013010",
    "34013050",
    "34023190",
    "34024990",
    "34025011",
    "34025051",
    "34029010",
    "34029030",
    "34029050",
    "34031910",
    "34031950",
    "34039900",
    "34051000",
    "34052000",
    "34054000",
    "34059000",
    "35061050",
    "35069110",
    "35069150",
    "35069900",
    "38085910",
    "38085940",
    "38086110",
    "38086150",
    "38086210",
    "38086250",
    "38086910",
    "38086950",
    "38089115",
    "38089125",
    "38089130",
    "38089150",
    "38089410",
    "38089450",
    "38099100",
    "38101000",
    "38111900",
    "38112100",
    "38140010",
    "38140020",
    "38140050",
    "38200000",
    "3824999397",
    "3827610000",
    "3827620000",
    "3827630000",
    "3827640000",
    "3827650000",
    "39252000",
    "39269010",
    "76141010",
    "8202390040",
    "82034060",
    "82055955",
    "82057000",
    "8207200070",
    "8207306062",
    "8207306095",
    "82111000",
    "82119110",
    "82119120",
    "82119125",
    "82119130",
    "82119140",
    "82119150",
    "82119180",
    "82119220",
    "82119240",
    "82119260",
    "82119290",
    "82119300",
    "82119410",
    "82119450",
    "82119510",
    "82119550",
    "82119590",
    "82151000",
    "82152000",
    "82159130",
    "82159160",
    "82159190",
    "82159901",
    "82159905",
    "82159910",
    "82159915",
    "82159920",
    "82159922",
    "82159924",
    "82159926",
    "82159930",
    "82159935",
    "82159940",
    "82159945",
    "82159950",
    "83021060",
    "83024130",
    "83024160",
    "83024230",
    "83024960",
    "83052000",
    "83071060",
    "8401400000",
    "84031000",
    "8406904000",
    "84072100",
    "84079010",
    "84079090",
    "84082010",
    "84082090",
    "84099150",
    "84099192",
    "84099199",
    "84099991",
    "84099992",
    "84099999",
    "8410900000",
    "84118180",
    "84122100",
    "84122980",
    "8412909070",
    "8412909075",
    "84138100",
    "8413919055",
    "8413919060",
    "8413919096",
    "8413919099",
    "84143040",
    "84148016",
    "84149030",
    "84149041",
    "84151030",
    "84151060",
    "84151090",
    "84158101",
    "84158201",
    "84158300",
    "84159040",
    "84159080",
    "8417900000",
    "84182100",
    "84182920",
    "84189940",
    "84198150",
    "84212900",
    "8424100000",
    "84248990",
    "84254200",
    "84262000",
    "84269900",
    "84271040",
    "84271080",
    "84272040",
    "84272080",
    "84279000",
    "84283200",
    "84283300",
    "84283900",
    "84286000",
    "84287000",
    "84289003",
    "84291100",
    "84291900",
    "84292000",
    "84293000",
    "84294000",
    "84295110",
    "84295150",
    "84295210",
    "84295250",
    "84295910",
    "84295950",
    "84312000",
    "84313900",
    "84314100",
    "84314340",
    "84314380",
    "84331100",
    "84332000",
    "84335100",
    "84335900",
    "84339010",
    "84339050",
    "8443160000",
    "8454200010",
    "8454200060",
    "84553000",
    "8455904000",
    "8455908000",
    "84571000",
    "84749000",
    "84771030",
    "84771040",
    "84771090",
    "84779025",
    "8477908601",
    "84798955",
    "84798965",
    "84799045",
    "84799055",
    "84799065",
    "84799075",
    "84799085",
    "84799095",
    "8479909591",
    "8480490010",
    "8480718045",
    "8480718060",
    "8480799010",
    "8482105004",
    "8482105008",
    "8482105012",
    "8482105016",
    "8482105024",
    "8482105028",
    "8482105032",
    "8482105036",
    "8482105052",
    "8482105056",
    "8482105060",
    "8482105064",
    "8482105068",
    "8482200064",
    "8482200067",
    "8482200090",
    "84829905",
    "84829915",
    "84829925",
    "84829935",
    "84829945",
    "84829965",
    "8483101010",
    "8483101050",
    "84831050",
    "84832040",
    "84832080",
    "84833040",
    "84833080",
    "84834010",
    "8483405020",
    "84834090",
    "84835060",
    "84835090",
    "84836040",
    "84836080",
    "84839020",
    "84839030",
    "84839050",
    "84839070",
    "84839080",
    "85015340",
    "85015360",
    "85015380",
    "8501640110",
    "8502310000",
    "85030035",
    "85030045",
    "85030065",
    "85030075",
    "85030090",
    "85030095",
    "85042300",
    "85043300",
    "8504909634",
    "8504909638",
    "8504909642",
    "85142040",
    "85142060",
    "85162900",
    "85166060",
    "86011000",
    "86012000",
    "86021000",
    "86029000",
    "86031000",
    "86039000",
    "86040000",
    "86050000",
    "86071100",
    "8607190300",
    "86071906",
    "86071912",
    "86071915",
    "86071990",
    "86072150",
    "8607301010",
    "8607301050",
    "8607301090",
    "86073050",
    "86079100",
    "86079950",
    "86090000",
    "87011001",
    "8701210080",
    "8701220080",
    "8701230080",
    "8701240080",
    "8701290080",
    "87013010",
    "87013050",
    "87019110",
    "87019150",
    "87019210",
    "87019250",
    "87019310",
    "87019350",
    "87019410",
    "87019450",
    "87019510",
    "87019550",
    "87021031",
    "87021061",
    "87031010",
    "87031050",
    "87032101",
    "87051000",
    "87052000",
    "8705900010",
    "8705900020",
    "87060030",
    "87084030",
    "87084060",
    "87089210",
    "87089250",
    "87089260",
    "87089275",
    "87089315",
    "87089330",
    "87089923",
    "87089981",
    "87100000",
    "87113000",
    "87115000",
    "87116000",
    "87141000",
    "87161000",
    "87163900",
    "87168010",
    "87168050",
    "87169010",
    "87169030",
    "94017100",
    "94017900",
    "94031000",
    "94039910",
    "9403999010",
    "9403999015",
    "9403999040",
    "9403999045",
    "9403999051",
    "9403999061",
    "95069100",
    "84181000",
    "84512100",
    "84512900",
    "84501100",
    "84502000",
    "84221100",
    "84183000",
    "84184000",
    "85166040",
    "85098020",
    "9403999020",
    "9403200082"
 ]
export const steelMeltAndPourHTSBeginnings = [
        //720610 through 7216.50
    "72061",
    "72062",
    "72063",
    "72064",
    "72065",
    "72066",
    "72067",
    "72068",
    "72069",
    "7207",
    "7208",
    "7209",
    "7210",
    "7211",
    "7212",
    "7213",
    "7214",
    "7215",
    "72160",
    "72161",
    "72162",
    "72163",
    "72164",
    "721650",
    
    //7216.99 through 7301.10
    "721699",
    "7217",
    "7218",
    "7219",
    "722",
    "723",
    "724",
    "725",
    "726",
    "727",
    "728",
    "729",
    "7300",
    "73010",
    "730110",
    
    //7302.10
    "730210",
    
    
    ///7302.40 through 7302.90
    "73024",
    "73025",
    "73026",
    "73027",
    "73028",
    "730290",
    
    //7304.10 through 7306.90
    "73041",
    "73042",
    "73043",
    "73044",
    "73045",
    "73046",
    "73047",
    "73048",
    "73049",
    "7305",
    "73060",
    "73061",
    "73062",
    "73063",
    "73064",
    "73065",
    "73066",
    "73067",
    "73068",
    "730690",
    
    
    //Derivative Steel HTS codes must trigger Steel form: 
    "73170030",
    "7317005503",
    "7317005505",
    "7317005507",
    "7317005560",
    "7317005580",
    "7317006560",
    "87081030",
    "87082921",
    "73012010",
    "73012050",
    "73023000",
    "73072110",
    "73072150",
    "73072210",
    "73072250",
    "73072300",
    "73072900",
    "73079110",
    "73079130",
    "73079150",
    "73079230",
    "73079290",
    "73079330",
    "73079360",
    "73079390",
    "73079910",
    "73079930",
    "73079950",
    "73081000",
    "73082000",
    "73083010",
    "73083050",
    "73084000",
    "73089030",
    "73089060",
    "73089070",
    "73089095",
    "73090000",
    "73101000",
    "73102100",
    "73102900",
    "73110000",
    "73121005",
    "73121010",
    "73121020",
    "73121030",
    "73121050",
    "73121060",
    "73121070",
    "73121080",
    "73121090",
    "73129000",
    "73130000",
    "73141210",
    "73141220",
    "73141230",
    "73141260",
    "73141290",
    "73141410",
    "73141420",
    "73141430",
    "73141460",
    "73141490",
    "73141901",
    "73142000",
    "73143110",
    "73143150",
    "73143900",
    "73144100",
    "73144200",
    "73144930",
    "73144960",
    "73145000",
    "73151100",
    "73151200",
    "73151900",
    "73152010",
    "73152050",
    "73158100",
    "73158210",
    "73158230",
    "73158250",
    "73158270",
    "73158910",
    "73158930",
    "73158950",
    "73159000",
    "73160000",
    "73170010",
    "73170020",
    "73170030",
    "73170055",
    "73170065",
    "73170075",
    "73181100",
    "73181200",
    "73181300",
    "73181410",
    "73181450",
    "73181520",
    "73181540",
    "73181550",
    "73181560",
    "73181580",
    "73181600",
    "73181900",
    "73182100",
    "73182200",
    "73182300",
    "73182400",
    "73182900",
    "73194020",
    "73194030",
    "73194050",
    "73199010",
    "73199090",
    "73201030",
    "73201060",
    "73201090",
    "73202010",
    "73202050",
    "73209010",
    "73209050",
    "73211110",
    "73211130",
    "73211160",
    "73211200",
    "73211900",
    "73218110",
    "73218150",
    "73218210",
    "73218250",
    "73218900",
    "73219010",
    "73219020",
    "73219040",
    "73219050",
    "73219060",
    "73221900",
    "73229000",
    "73231000",
    "73239300",
    "73239400",
    "73239910",
    "73239930",
    "73239950",
    "73239970",
    "73239990",
    "73241000",
    "73242900",
    "73249000",
    "73259100",
    "73259910",
    "73259950",
    "73261100",
    "73261900",
    "73262000",
    "73269010",
    "73269025",
    "73269035",
    "73269045",
    "73269060",
    "73269086",
    "84313100",
    "84314200",
    "84314910",
    "84314990",
    "84321000",
    "84329000",
    "85479000",
    "94032000",
    "94059920",
    "94059940",
    "94062000",
    "94069001",
    //NEW ->
    "7206",
    "7207",
    "7208",
    "7209",
    "7210",
    "7211",
    "7212",
    "7213",
    "7214",
    "7215",
    "721610",
    "721610",
    "721621",
    "721622",
    "721631",
    "721632",
    "721633",
    "721640",
    "721650",
    "721699",
    "7217",
    "7218",
    "7219",
    "7220",
    "7221",
    "7222",
    "7223",
    "7224",
    "7225",
    "7226",
    "7227",
    "7228",
    "7229",
    "73011000",
    "730210",
    "73024000",
    "73029000",
    "7304",
    "7305",
    "7306",
    "73170030",
    "7317005503",
    "7317005505",
    "7317005507",
    "7317005560",
    "7317005580",
    "7317006560",
    "87081030",
    "87082921",
    "73012010",
    "73012050",
    "73023000",
    "73072110",
    "73072150",
    "73072210",
    "73072250",
    "73072300",
    "73072900",
    "73079110",
    "73079130",
    "73079150",
    "73079230",
    "73079290",
    "73079330",
    "73079360",
    "73079390",
    "73079910",
    "73079930",
    "73079950",
    "73081000",
    "73082000",
    "73083010",
    "73083050",
    "73084000",
    "73089030",
    "73089060",
    "73089070",
    "73089095",
    "73090000",
    "73101000",
    "73102100",
    "73102900",
    "73110000",
    "73121005",
    "73121010",
    "73121020",
    "73121030",
    "73121050",
    "73121060",
    "73121070",
    "73121080",
    "73121090",
    "73129000",
    "73130000",
    "73141210",
    "73141220",
    "73141230",
    "73141260",
    "73141290",
    "73141410", 
    "73141420",
    "73141430",
    "73141460",
    "73141490",
    "73141901",
    "73142000",
    "73143110",
    "73143150",
    "73143900",
    "73144100",
    "73144200",
    "73144930",
    "73144960",
    "73145000",
    "73151100",
    "73151200",
    "73151900",
    "73152010",
    "73152050",
    "73158100",
    "73158210",
    "73158230",
    "73158250",
    "73158270",
    "73158910",
    "73158930",
    "73158950",
    "73159000",
    "73160000",
    "73170010",
    "73170020",
    "7317005501",
    "7317005502",
    "7317005508",
    "7317005511",
    "7317005518",
    "7317005519",
    "7317005520",
    "7317005530",
    "7317005540",
    "7317005550",
    "7317005570",
    "7317005590",
    "7317006530",
    "73170075",
    "73181100",
    "73181200",
    "73181300",
    "73181410",
    "73181450",
    "73181520",
    "73181540",
    "73181550",
    "73181560",
    "73181580",
    "73181600",
    "73181900",
    "73182100",
    "73182200",
    "73182300",
    "73182400",
    "73182900",
    "73194020",
    "73194030",
    "73194050",
    "73199010",
    "73199090",
    "73201030",
    "73201060",
    "73201090",
    "73202010",
    "73202050",
    "73209010",
    "73209050",
    "73211110",
    "73211130",
    "73211160",
    "73211200",
    "73211900",
    "73218110",
    "73218150",
    "73218210",
    "73218250",
    "73218900",
    "73219010",
    "73219020",
    "73219040",
    "73219050",
    "73219060",
    "73221900",
    "73229000",
    "73231000",
    "73239300",
    "73239400",
    "73239910",
    "73239930",
    "73239950",
    "73239970",
    "73239990",
    "73241000",
    "73242900",
    "73249000",
    "73259100",
    "73259910",
    "73259950",
    "73261100",
    "73261900",
    "73262000",
    "73269010",
    "73269025",
    "73269035",
    "73269045",
    "73269060",
    "73269086",
    "84313100",
    "84314200",
    "84314910",
    "84314990",
    "84321000",
    "84329000",
    "85479000",
    "94032000",
    "94059920",
    "94059940",
    "94062000",
    "94069001",
    // additional HTS codes for steel melt and pour
    ...additionalHTSForSteelMeltAndPour
]

export const aluminiumMeltAndPour =  [
        // Aluminium
    "6603908100",
    "76101000",
    "76109000",
    "7615102015",
    "7615102025",
    "7615103015",
    "7615103025",
    "7615105020",
    "7615105040",
    "7615107125",
    "7615107130",
    "7615107155",
    "7615107180",
    "7615109100",
    "7615200000",
    "7616109090",
    "7616991000",
    "7616995130",
    "7616995140",
    "7616995190",
    "8302103000",
    "8302106030",
    "8302106060",
    "8302106090",
    "8302200000",
    "8302303010",
    "8302303060",
    "8302413000",
    "8302416015",
    "8302416045",
    "8302416050",
    "8302416080",
    "8302423010",
    "8302423015",
    "8302423065",
    "8302496035",
    "8302496045",
    "8302496055",
    "8302496085",
    "8302500000",
    "8302603000",
    "8302609000",
    "8305100050",
    "8306300000",
    "8414596590",
    "8415908025",
    "8415908045",
    "8415908085",
    "8418998005",
    "8418998050",
    "8418998060",
    "8419505000",
    "8419901000",
    "8422900640",
    "8424909080",
    "8473302000",
    "8473305100",
    "8479899599",
    "8479908500",
    "8479909596",
    "8481909060",
    "8481909085",
    "8486900000",
    "8487900080",
    "8503009520",
    "8508700000",
    "8513902000",
    "8515902000",
    "8516905000",
    "8516908050",
    "8517710000",
    "8517790000",
    "8529907300",
    "8529909760",
    "8536908585",
    "8538100000",
    "8541900000",
    "8543908885",
    "8547900020",
    "8547900030",
    "8547900040",
    "8708103050",
    "87081060",
    "8708295160",
    "8708806590",
    "8708996890",
    "8716805010",
    "8807300060",
    "9013908000",
    "9031909195",
    "9401999081",
    "94031000",
    "94032000",
    "9403991040",
    "9403999010",
    "9403999015",
    "9403999020",
    "9403999040",
    "9403999045",
    "9405994020",
    "9506114080",
    "9506514000",
    "9506516000",
    "9506594040",
    "9506702090",
    "9506910010",
    "9506910020",
    "9506910030",
    "9506990510",
    "9506990520",
    "9506990530",
    "9506991500",
    "9506992000",
    "9506992580",
    "9506992800",
    "9506995500",
    "9506996080",
    "9507302000",
    "9507304000",
    "9507306000",
    "9507308000",
    "9507906000",
    "9603908050",
    //9403
    "94031000",
    "94032000",
    "9403991040",
    "9403999010",
    "9403999015",
    "9403999020",
    "9403999040",
    "9403999045",
    //NEw ->
    "7601",
    "7604",
    "7605",
    "7606",
    "7607",
    "7608",
    "7609",
    "76169951",
    "76141050",
    "76149020",
    "76149040",
    "76149050",
    "87081030",
    "87082921",
    "76101000",
    "76109000",
    "76129010",
    "7615102015",
    "7615102025",
    "7615103015",
    "7615103025",
    "7615105020",
    "7615105040",
    "7615107125",
    "7615107130",
    "7615107155",
    "7615107180",
    "7615109100",
    "7615200000",
    "7616109090",
    "7616991000",
    "7616995130",
    "7616995140",
    "7616995190",
    "2203000060",
    "2203000090",
    "6603908100",
    "8302103000",
    '8479909591',
    "8302106030",
    "8302106060",
    "8302106090",
    "8302200000",
    "8302303010",
    "8302303060",
    "8302413000",
    "8302416015",
    "8302416045",
    "8302416050",
    "8302416080",
    "8302423010",
    "8302423015",
    "8302423065",
    "8302496035",
    "8302496045",
    "8302496055",
    "8302496085",
    "8302500000",
    "8302603000",
    "8302609000",
    "8305100050",
    "8306300000",
    "8414596590",
    "8415908025",
    "8415908045",
    "8415908085",
    "8418998005",
    "8418998050",
    "8418998060",
    "8419505000",
    "8419901000",
    "8422900640",
    "8424909080",
    "8473302000",
    "8473305100",
    "8479899599",
    "8479908500",
    "8479909596",
    "8481909060",
    "8481909085",
    "8486900000",
    "8487900080",
    "8503009520",
    "8508700000",
    "8513902000",
    "8515902000",
    "8516905000",
    "8516908050",
    "8517710000",
    "8517790000",
    "8529907300",
    "8529909760",
    "8536908585",
    "8538100000",
    "8541900000",
    "8543908885",
    "8547900020",
    "8547900030",
    "8547900040",
    "8708103050",
    "87081060",
    "8708295160",
    "8708806590",
    "8708996890",
    "8716805010",
    "8807300060",
    "9013908000",
    "9031909195",
    "9401999081",
    "94031000",
    "94032000",
    "9403991040",
    "9403999010",
    "9403999015",
    "9403999020",
    "9403999040",
    "9403999045",
    "9405994020",
    "9506114080",
    "9506514000",
    "9506516000",
    "9506594040",
    "9506702090",
    "9506910010",
    "9506910020",
    "9506910030",
    "9506990510",
    "9506990520",
    "9506990530",
    "9506991500",
    "9506992000",
    "9506992580",
    "9506992800",
    "9506995500",
    "9506996080",
    "9507302000",
    "9507304000",
    "9507306000",
    "9507308000",
    "9507906000",
    "9603908050",
    "6603908100",
    "76101000",
    "76109000",
    "7615102015",
    "7615102025",
    "7615103015",
    "7615103025",
    "7615105020",
    "7615105040",
    "7615107125",
    "7615107130",
    "7615107155",
    "7615107180",
    "7615109100",
    "7615200000",
    "7616109090",
    "7616991000",
    "7616995130",
    "7616995140",
    "7616995190",
    "8302103000",
    "8302106030",
    "8302106060",
    "8302106090",
    "8302200000",
    "8302303010",
    "8302303060",
    "8302413000",
    "8302416015",
    "8302416045",
    "8302416050",
    "8302416080",
    "8302423010",
    "8302423015",
    "8302423065",
    "8302496035",
    "8302496045",
    "8302496055",
    "8302496085",
    "8302500000",
    "8302603000",
    "8302609000",
    "8305100050",
    "8306300000",
    "8414596590",
    "8415908025",
    "8415908045",
    "8415908085",
    "8418998005",
    "8418998050",
    "8418998060",
    "8419505000",
    "8419901000",
    "8422900640",
    "8424909080",
    "8473302000",
    "8473305100",
    "8479899599",
    "8479908500",
    "8479909596",
    "8481909060",
    "8481909085",
    "8486900000",
    "8487900080",
    "8503009520",
    "8508700000",
    "8513902000",
    "8515902000",
    "8516905000",
    "8516908050",
    "8517710000",
    "8517790000",
    "8529907300",
    "8529909760",
    "8536908585",
    "8538100000",
    "8541900000",
    "8543908885",
    "8547900020",
    "8547900030",
    "8547900040",
    "8708103050",
    "87081060",
    "8708295160",
    "8708806590",
    "8708996890",
    "8716805010",
    "8807300060",
    "9013908000",
    "9031909195",
    "9401999081",
    "94031000",
    "94032000",
    "9403991040",
    "9403999010",
    "9403999015",
    "9403999020",
    "9403999040",
    "9403999045",
    "9405994020",
    "9506114080",
    "9506514000",
    "9506516000",
    "9506594040",
    "9506702090",
    "9506910010",
    "9506910020",
    "9506910030",
    "9506990510",
    "9506990520",
    "9506990530",
    "9506991500",
    "9506992000",
    "9506992580",
    "9506992800",
    "9506995500",
    "9506996080",
    "9507302000",
    "9507304000",
    "9507306000",
    "9507308000",
    "9507906000",
    "9603908050",
    "9401999070",
    // Additional HTS codes 

  "7612100000",
  "7612905000",
  "7613000000",
  "76141010",
  "04029968",
  "04029970",
  "04029990",
  "2106909998",
  "2710193050",
  "29034310",
  "29034510",
  "29034900",
  "29035110",
  "29035990",
  "3004909244",
  "32081000",
  "32082000",
  "32089000",
  "32091000",
  "32099000",
  "32139000",
  "32141000",
  "33030010",
  "33030020",
  "33030030",
  "33043000",
  "33049950",
  "33051000",
  "33053000",
  "33059000",
  "33069000",
  "33071010",
  "33071020",
  "33072000",
  "33074900",
  "33079000",
  "34013010",
  "34013050",
  "34023190",
  "34024990",
  "34025011",
  "34025051",
  "34029010",
  "34029030",
  "34029050",
  "34031910",
  "34031950",
  "34039900",
  "34051000",
  "34052000",
  "34054000",
  "34059000",
  "35061050",
  "35069110",
  "35069150",
  "35069900",
  "3701300000",
  "38085910",
  "38085940",
  "38086110",
  "38086150",
  "38086210",
  "38086250",
  "38086910",
  "38086950",
  "38089115",
  "38089125",
  "38089130",
  "38089150",
  "38089410",
  "38089450",
  "38099100",
  "38101000",
  "38111900",
  "38112100",
  "38140010",
  "38140020",
  "38140050",
  "38200000",
  "3824999397",
  "7308200035",
  "8307906000",
  "8309900020",
  "8309900025",
  "8412909070",
  "8412909075",
  "84148016",
  "84181000",
  "8419501000",
  "84248990",
  "8443160000",
  "84501100",
  "84512100",
  "84672200",
  "84672900",
  "84678100",
  "84678950",
  "8483405020",
  "8483905020",
  "8501640110",
  "85022000",
  "8502310000",
  "8503009546",
  "8503009570",
  "85043120",
  "85043140",
  "85043160",
  "85043300",
  "85043400",
  "85049020",
  "85049041",
  "85049065",
  "85049075",
  "85049096",
  "85441900",
  "85444290",
  "8544492000",
  "8544499000",
  "8544602000",
  "8544606000",
  "8716390040",
  "94017900",
  "9403200082"
    
];

const April6th2026List = [
  "04029968",
  "04029970",
  "04029990",
  "2106909998",
  "2710193050",
  "2711120020",
  "2804290010",
  "2804400000",
  "2901220000",
  "2903421000",
  "29034310",
  "29034410",
  "29034510",
  "29034900",
  "29035110",
  "29035990",
  "2903710100",
  "3004909251",
  "32081000",
  "32082000",
  "32089000",
  "32091000",
  "32099000",
  "32139000",
  "32141000",
  "33030010",
  "33030020",
  "33030030",
  "33043000",
  "33049950",
  "33051000",
  "33053000",
  "33059000",
  "33069000",
  "33071010",
  "33071020",
  "33072000",
  "33074900",
  "33079000",
  "34013010",
  "34013050",
  "34023190",
  "34024990",
  "34025011",
  "34025051",
  "34029010",
  "34029030",
  "34029050",
  "34031910",
  "34031950",
  "34039900",
  "34051000",
  "34052000",
  "34054000",
  "34059000",
  "35061050",
  "35069110",
  "35069150",
  "35069900",
  "38085910",
  "38085940",
  "38086110",
  "38086150",
  "38086210",
  "38086250",
  "38086910",
  "38086950",
  "38089115",
  "38089125",
  "38089130",
  "38089150",
  "38089410",
  "38089450",
  "38099100",
  "38101000",
  "38111900",
  "38112100",
  "38140010",
  "38140020",
  "38140050",
  "38200000",
  "3824999397",
  "3827610000",
  "3827620000",
  "3827630000",
  "3827640000",
  "3827650000",
  "39252000",
  "39269010",
  "7323915020",
  "7323915040",
  "7323920020",
  "7323920040",
  "84072100",
  "84082010",
  "84082090",
  "84099150",
  "84099192",
  "84099199",
  "84099991",
  "84099992",
  "84099999",
  "85015340",
  "84241000",
  "85030045",
  "85030090",
  "8705900010",
  "8705900020",
  "87100000",
  "87113000",
  "87115000",
  "87116000",
  "87141000",
  "94017100",
  "94017900",
  "94031000",
  "94032000",
  "94039910",
  "9403999010",
  "9403999015",
  "9403999040",
  "9403999045",
  "9403999051",
  "9403999061",
  "94059920",
  "94059940",
  "95069100",
  "04029968",
  "04029970",
  "04029990",
  "2106909998",
  "22030000",
  "2710193050",
  "29034310",
  "29034510",
  "29034900",
  "29035110",
  "29035990",
  "3004909251",
  "32081000",
  "32082000",
  "32089000",
  "32091000",
  "32099000",
  "32139000",
  "32141000",
  "33030010",
  "33030020",
  "33030030",
  "33043000",
  "33049950",
  "33051000",
  "33053000",
  "33059000",
  "33069000",
  "33071010",
  "33071020",
  "33072000",
  "33074900",
  "33079000",
  "34013010",
  "34013050",
  "34023190",
  "34024990",
  "34025011",
  "34025051",
  "34029010",
  "34029030",
  "34029050",
  "34031910",
  "34031950",
  "34039900",
  "34051000",
  "34052000",
  "34054000",
  "34059000",
  "35061050",
  "35069110",
  "35069150",
  "35069900",
  "3701300000",
  "38085910",
  "38085940",
  "38086110",
  "38086150",
  "38086210",
  "38086250",
  "38086910",
  "38086950",
  "38089115",
  "38089125",
  "38089130",
  "38089150",
  "38089410",
  "38089450",
  "38099100",
  "38101000",
  "38111900",
  "38112100",
  "38140010",
  "38140020",
  "38140050",
  "38200000",
  "3824999397",
  "6603908100",
  "8473302000",
  "8473305100",
  "8486900000",
  "8517790000",
  "8529909760",
  "8541900000",
  "8807300060",
  "9031909195",
  "94017900",
  "9401999081",
  "94031000",
  "94032000",
  "9403991040",
  "9403999010",
  "9403999015",
  "9403999020",
  "9403999040",
  "9403999045",
  "9405994020",
  "9506114080",
  "9506514000",
  "9506516000",
  "9506594040",
  "9506702090",
  "9506910010",
  "9506910020",
  "9506910030",
  "9506990510",
  "9506990520",
  "9506990530",
  "9506991500",
  "9506992000",
  "9506992580",
  "9506992800",
  "9506995500",
  "9506996080",
  "9507302000",
  "9507304000",
  "9507306000",
  "9507308000",
  "9507906000",
  "9603908050"]

const APRIL_6_2026_EPOCH_MS = 1775433600000;
const normalizeEpochToMs = (epoch) => {
  const numericEpoch = Number(epoch || 0);
  if (!numericEpoch) return 0;
  // Support both epoch-seconds and epoch-milliseconds inputs.
  return numericEpoch < 1000000000000 ? numericEpoch * 1000 : numericEpoch;
};

const resolveDateByHtsPrecedenceMs = ({ itDate, releaseDate, entryDate }) => {
  // Match GET_HTS_METADATA_US precedence: IT -> Release -> Entry.
  const prioritizedDates = [
    normalizeEpochToMs(itDate),
    normalizeEpochToMs(releaseDate),
    normalizeEpochToMs(entryDate),
    0
  ];
  return prioritizedDates.find((date) => date >= 1000) || 0;
};

// Returns aluminum melt/pour HTS codes, applying April 6, 2026 filtering based
// on the precedence date (IT -> Release -> Entry).
export const getAluminumMeltAndPourCodes = ({itDate, entryDate, releaseDate})=>{
  console.log('getAluminumMeltAndPourCodes date context', { itDate, entryDate, releaseDate });
  const resolvedDate = resolveDateByHtsPrecedenceMs({ itDate, releaseDate, entryDate });
  // Filter list on/after Apr 6, 2026.
  if (resolvedDate >= APRIL_6_2026_EPOCH_MS) {
    return aluminiumMeltAndPour.filter(hts => !April6th2026List.includes(hts)) || [];
  }
    return aluminiumMeltAndPour || []
  }

export const getSteelMeltAndPourCodes = ({itDate, entryDate, releaseDate}) => {
  // Returns steel melt/pour HTS prefixes with the same cutoff filtering logic
  // as aluminum, based on IT/Entry/Release date context.
  console.log('getSteelMeltAndPourCodes date context', { itDate, entryDate, releaseDate });
  const resolvedDate = resolveDateByHtsPrecedenceMs({ itDate, releaseDate, entryDate });
  // Filter list on/after Apr 6, 2026.
  if (resolvedDate >= APRIL_6_2026_EPOCH_MS) {
    return steelMeltAndPourHTSBeginnings.filter(hts => !April6th2026List.includes(hts)) || [];
  }
  return steelMeltAndPourHTSBeginnings || [];
}

export const copperSmeltAndCastHTSBeginnings = [
  "85444210",
  "85444220",
  "85444290",
  "85444910",
];

export const getCopperSmeltAndCastCodes = () => {
  return copperSmeltAndCastHTSBeginnings || [];
}

/** COO codes that must not auto-trigger Aluminum / Steel / Copper melt-smelt-cast fields */
export const MELT_SMELT_CAST_EXEMPT_COO = ["US", "VI", "GU", "AS", "UM", "PR", "MP"];

export const isMeltSmeltCastExemptCOO = (coo) =>
  MELT_SMELT_CAST_EXEMPT_COO.includes(String(coo || "").toUpperCase());

export const russiaMetaData = {//note, just just for russia, has all cast HTSes
    "FTZ": {
        "7601": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7604": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7605": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7606": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7607": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7608": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7609": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7616995160": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7616995170": {
            "hts": "99038569",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76141050": {
            "hts": "99038570",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76149020": {
            "hts": "99038570",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76149040": {
            "hts": "99038570",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76149050": {
            "hts": "99038570",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "8708292130": {
            "hts": "99038570",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "8708103030": {
            "hts": "99038570",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        }
    },
    "nonFTZ": {
        "7601": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7604": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7605": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7605": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7606": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7607": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7608": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7609": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7616995160": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "7616995170": {
            "hts": "99038567",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76141050": {
            "hts": "99038568",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76149020": {
            "hts": "99038568",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76149040": {
            "hts": "99038568",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "76149050": {
            "hts": "99038568",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "8708292130": {
            "hts": "99038568",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        },
        "8708103030": {
            "hts": "99038568",
            "dutyRate": "200",
            "htsDescription": "19(b)"
        }
    }
}


export const steelAndAluminiumHts = [
    "99038508",
    "99038191", 
    "99038187",
    "99038188",
    "99038189",
    "99038190",
    "99038193",
    "99038502",
    "99038504",
    "99038507",
    "99038194",
    "99038195",
    "99038196",
    "99038197",
    "99038198",
    "99038512",
    "99038513",
    "99038514",
    "99038515",
    "99038203"
]

export const copperHts = [
    "99037801"
]

export const showNetQtyOrCbpQty1 = (htsNo="") => {
    const hts = htsNo?.replace(/\./g, "");
    return hts && (steelAndAluminiumHts.includes(hts) || copperHts.includes(hts))
}

export const DECLARATIONS_ENUMS = {
    AD_CVD_CERTIFICATION: "AD_CVD_CERTIFICATION",
    _201_BIFACIAL_CERTIFICATION: "_201_BIFACIAL_CERTIFICATION",
    SHIP_TO_SHORE_CRANE_CERT    : "SHIP_TO_SHORE_CRANE_CERTIFICATION",
    ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL: "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL",
    STEEL_MELT_AND_POUR_COUNTRY_DETAIL: "STEEL_MELT_AND_POUR_COUNTRY_DETAIL",
    AUTO_PARTS_OFFSET_LICENSE: "AUTO_PARTS_OFFSET_LICENSE",
    COPPER_SMELT_AND_CAST_COUNTRY_DETAIL: "COPPER_SMELT_AND_CAST_COUNTRY_DETAIL",
  };  

export const declarationTemplates = {
  AUTO_PARTS_OFFSET_LICENSE: {
    typeCode: DECLARATIONS_ENUMS.AUTO_PARTS_OFFSET_LICENSE,
    autoPartsOffsetLicenseDetail: {
      licenseNumber: "",
    },
  },
    STEEL_MELT_AND_POUR_COUNTRY_DETAIL: {
      typeCode: DECLARATIONS_ENUMS.STEEL_MELT_AND_POUR_COUNTRY_DETAIL,
      steelMeltAndPourCountryDetail: {
        countryOfMeltAndPour: "yes",
        countryOfMeltAndPourCode: "",
        countryOfMeltAndPourApplicabilityCode: "no",
      },
    },
    ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL: {
      typeCode: DECLARATIONS_ENUMS.ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL,
      aluminumSmeltAndCastCountryDetail: {
        doNotShowAluminum: false,
        isUsProduct: "no",
        isPrimaryCountryOfSmeltApplied: "yes",
        primaryCountryOfSmelt: "",
        isSecondCountryOfSmeltApplied: "yes",
        secondaryCountryOfSmelt: "",
        countryOfCast: "",
      },
    },
    COPPER_SMELT_AND_CAST_COUNTRY_DETAIL: {
      typeCode: DECLARATIONS_ENUMS.COPPER_SMELT_AND_CAST_COUNTRY_DETAIL,
      copperSmeltAndCastCountryDetail: {
        doNotShowCopper: false,
        isSecondCountryOfSmeltApplied: "yes",
        primaryCountryOfSmelt: "",
        secondaryCountryOfSmelt: "",
        countryOfMostRecentCast: "",
      },
    },
  };

export const DECLARATION_OPTIONS = [
    {
      key: '1',
      text: 'AD/CVD',
      value: 'AD_CVD_CERTIFICATION',
      information: 'ADCVD CERT',
      typeCode: 'AD_CVD_CERTIFICATION',
    },
    {
      key: '2',
      text: '201 Bifacial',
      value: '_201_BIFACIAL_CERTIFICATION',
      information: '201BIFAC CERT',
      typeCode: '_201_BIFACIAL_CERTIFICATION',
    },
    {
      key: '3',
      text: 'Ship-to-Shore Crane',
      value: 'SHIP_TO_SHORE_CRANE_CERTIFICATION',
      information: '301STS CERT',
      typeCode: 'SHIP_TO_SHORE_CRANE_CERTIFICATION',
    },
    {
      key: '4',
      text: 'Auto Parts Offset License',
      value: DECLARATIONS_ENUMS.AUTO_PARTS_OFFSET_LICENSE,
      information: 'Auto Parts Offset License',
      typeCode: 'Auto Parts Offset License',
    },
    {
      key: '5',
      text: 'Aluminum Smelt and Cast Country Detail',
      value: DECLARATIONS_ENUMS.ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL,
      information: 'Aluminum Smelt and Cast',
      typeCode: 'Aluminum Smelt and Cast Country Detail',
    },
    {
      key: '6',
      text: 'Steel Melt and Pour Country Detail',
      value:DECLARATIONS_ENUMS.STEEL_MELT_AND_POUR_COUNTRY_DETAIL,
      information: 'Steel Melt and Pour',
      typeCode: 'Steel Melt and Pour Country Detail',
    },
    {
      key: '7',
      text: 'Copper Smelt and Cast Country Detail',
      value:DECLARATIONS_ENUMS.COPPER_SMELT_AND_CAST_COUNTRY_DETAIL,
      information: 'Copper Smelt and Cast',
      typeCode: 'Copper Smelt and Cast Country Detail',
    },
  ];

export const AUTO_PARTS_OFFSET_LICENSE_FIELD_NAME = 'autoPartsOffsetLicenseNumber';
export const AUTO_PARTS_OFFSET_LICENSE_REGEX = /^[A-Za-z]{2}[0-9]{6}$/;
export const AUTO_PARTS_OFFSET_LICENSE_MAX_LENGTH = 8;

export const euTariffCountries = [
  "AT", // Austria
  "BE", // Belgium
  "BG", // Bulgaria
  "HR", // Croatia
  "CY", // Cyprus
  "CZ", // Czech Republic
  "DK", // Denmark
  "EE", // Estonia
  "FI", // Finland
  "FR", // France
  "DE", // Germany
  "GR", // Greece
  "HU", // Hungary
  "IE", // Ireland
  "IT", // Italy
  "LV", // Latvia
  "LT", // Lithuania
  "LU", // Luxembourg
  "MT", // Malta
  "NL", // Netherlands
  "PL", // Poland
  "PT", // Portugal
  "RO", // Romania
  "SK", // Slovakia
  "SI", // Slovenia
  "ES", // Spain
  "SE",  // Sweden
  "JP",  // Japan
];

/**
 * Maps API codes to display values and descriptions
 */
export const INTENDED_USE_CODE_CONVERSIONS = {
  "080.012": {
    value: "080.012",
    description:
      "Prescription health or medical product for human use that is the subject of an approved new drug application, abbreviated new drug application, or biologics license application",
  },
  "100.000": {
    value: "100.000",
    description: "Importation for Personal Use",
  },
  "130.000": {
    value: "130.000",
    description:
      "For Consumer Use as a Non- Food Product – Over the Counter (OTC)",
  },
  "150.007": {
    value: "150.007",
    description:
      "Active Pharmaceutical Ingredient / Bulk Drug Substance for processing into a pharmaceutical product",
  },
  "150.013": {
    value: "150.013",
    description:
      "Active Pharmaceutical Ingredient / Bulk Drug Substance to be used for Pharmacy Compounding",
  },
  "150.017": {
    value: "150.017",
    description:
      "Importation of a drug component (API) for use in a medical product regulated under a device (CDRH) application type (e.g., for use in a PMA/510(k) drug-device combination product)",
  },
  "155.009": {
    value: "155.009",
    description:
      "Importation of a drug constituent part (drug product) for use in a medical product regulated under a device (CDRH) application type (e.g., for use in a PMA/510(k) drug-device combination product)",
  },
  "180.009": {
    value: "180.009",
    description:
      "Chemical for research and development of a pharmaceutical product – subject of an Investigational New Drug application (IND), including Placebos",
  },
  "180.017": {
    value: "180.017",
    description:
      "Chemical for research and development of a pharmaceutical product – laboratory testing only, no human/animal use",
  },
  "180.018": {
    value: "180.018",
    description:
      "Chemical for research and development of a pharmaceutical product –investigational use in animals",
  },
  "180.026": {
    value: "180.026",
    description:
      "Finished drug or API intended for use in an in vivo bioequivalence or bioavailability study in humans that qualifies under 21 CFR 320.31 for an exemption from the Part 312 requirements; or, finished drug intended for use in clinical investigation in humans that qualifies for an exemption from Part 312 requirement",
  },
  "920.000": { value: "920.000", description: "US Goods Returned" },
  "970.000": { value: "970.000", description: "Import for Export" },
  "980.000": {
    value: "980.000",
    description:
      "For Other Use: (APIs or Finished Drugs not elsewhere classified)Source Type Code39 - Country of Production30 - Country of Source (for a component)Party Entity Codes16 - DUNS47 - FEIAffirmations of ComplianceREG - Drug Registration NumberDLS - Drug Listing NumberIND - Investigational New Drug NumberERR - Entry Review RequestedPLR - Used to identify the shipment as a PLAIR import shipment",
  },
  "150.000": {
    value: "150.007",
    description:
      "For Commercial Processing as a NonFood Product",
  },
  "110.000": {
    value: "110.000",
    description:
      "For Public Exhibition or Display as a Non-Food Product",
  },
  "130.033": {
    value: "130.033",
    description:
      "Inactive ingredients and intermediates for use in a pharmaceutical product",
  },
  "155.000": {
    value: "155.000",
    description:
      "For Commercial Assembly as a Non-Food Product",
  },
  "180.000": {
    value: "180.000",
    description:
      "For Research and Development as a NonFood Product",
  },
  "130.029": {
    value: "130.029",
    description:
      "Chemical Substance for use in a food additive",
  },
};